<template>
  <div
    class="w-full p-1 opacity-40"
    :style="{
      backgroundImage: `linear-gradient(to right, #${primaryColor}, #${secondaryColor}, #${primaryColor})`
    }"
  />

  <div class="w-full flex justify-center py-8">
    <div class="max-w-[28rem] md:max-w-[64rem]">
      <div class="grid grid-cols-1 md:grid-cols-3 w-full gap-y-8 md:gap-x-12">
        <CircleImageBlock
          :title="extendedBodyConfig?.block_1_title"
          :text="extendedBodyConfig?.block_1_text"
          :image-url="extendedBodyConfig?.block_1_image_url"
          :primary-color="primaryColor"
        >
          <template #defaultImage>
            <img
              class="h-20 w-20 object-contain m-6"
              src="@timon/js/Templates/PRE-LANDER-001/assets/block-1-image.svg"
              alt="Image"
            >
          </template>
        </CircleImageBlock>

        <CircleImageBlock
          :title="extendedBodyConfig?.block_2_title"
          :text="extendedBodyConfig?.block_2_text"
          :image-url="extendedBodyConfig?.block_2_image_url"
          :primary-color="primaryColor"
        >
          <template #defaultImage>
            <img
              class="h-20 w-20 object-contain m-6"
              src="@timon/js/Templates/PRE-LANDER-001/assets/block-2-image.svg"
              alt="Image"
            >
          </template>
        </CircleImageBlock>

        <CircleImageBlock
          :title="extendedBodyConfig?.block_3_title"
          :text="extendedBodyConfig?.block_3_text"
          :image-url="extendedBodyConfig?.block_3_image_url"
          :primary-color="primaryColor"
        >
          <template #defaultImage>
            <img
              class="h-20 w-20 object-contain m-6"
              src="@timon/js/Templates/PRE-LANDER-001/assets/block-3-image.svg"
              alt="Image"
            >
          </template>
        </CircleImageBlock>
      </div>

      <SmallDivider
        :primary-color="primaryColor"
        :secondary-color="secondaryColor"
      />

      <Faq
        :config="extendedBodyConfig"
        :primary-color="primaryColor"
        :secondary-color="secondaryColor"
      />
    </div>
  </div>
</template>

<script setup>
import {ref} from 'vue';
import SmallDivider from '@timon/js/Templates/PRE-LANDER-001/Components/SmallDivider.vue';
import CircleImageBlock from '@timon/js/Templates/PRE-LANDER-001/Components/CircleImageBlock.vue';
import Faq from '@timon/js/Templates/PRE-LANDER-001/Components/Faq.vue';

const props = defineProps({
  config: {
    type: Object,
    required: true,
  },
});

const primaryColor = ref(props.config.style?.primary);
const secondaryColor = ref(props.config.style?.secondary);
const extendedBodyConfig = ref(props.config?.extended_body);
</script>
